import { GENRE_OPTIONS, MOOD_OPTIONS } from "../config/eventOptions";

// MVP "structuring" for the Import Event workflow.
//
// IMPORTANT: This does NOT scrape or fetch anything from the network. It only
// parses the plain text the admin has already pasted, plus the URL they typed.
// Every field it returns is a best-effort guess that the admin reviews and edits
// before saving the draft.
//
// SWAP POINT: later this whole function can be replaced by an AI / server-side
// extraction call. The return shape is the contract the Import drawer relies on,
// so the UI does not need to change when the implementation is upgraded.

const matchKnown = (text, options) => {
  const lower = text.toLowerCase();
  return options.filter((option) => lower.includes(option.toLowerCase()));
};

// Try to find an ISO-ish date (YYYY-MM-DD) or DD.MM.YYYY and normalize to the
// <input type="date"> format (YYYY-MM-DD).
const extractDate = (text) => {
  const iso = text.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return iso[0];
  const dmy = text.match(/\b(\d{1,2})[./](\d{1,2})[./](\d{4})\b/);
  if (dmy) {
    const [, d, m, y] = dmy;
    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }
  return "";
};

const extractImageUrl = (text) => {
  const match = text.match(/https?:\/\/\S+\.(?:png|jpe?g|webp|gif)(?:\?\S*)?/i);
  return match ? match[0] : "";
};

export const extractEventDraft = ({ text = "", url = "" } = {}) => {
  const lines = text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  const name = lines[0] || "";
  const genres = matchKnown(text, GENRE_OPTIONS);
  const moods = matchKnown(text, MOOD_OPTIONS);

  return {
    name,
    city: "",
    venue: "",
    date: extractDate(text),
    genres,
    moods,
    description: lines.slice(1).join("\n"),
    sourceUrl: url.trim(),
    imageUrl: extractImageUrl(text),
  };
};
